import { MyTrans } from '@halo/ui-react';
import { toasterCopy } from '..';

let debounceTimer: number | null;

export async function copyToClipboard(text: string | undefined, msg?: string) {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  debounceTimer = setTimeout(async () => {
    debounceTimer = null;

    if (!text) {
      return;
    }

    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);

      textArea.select();

      document.execCommand('copy');

      document.body.removeChild(textArea);
    }

    toasterCopy.success({
      title: msg || <MyTrans i18nKey="tips.copied" />,
    });
  }, 300);
}

export async function copyFileToClipboard(getFile: () => Promise<File>) {
  const id = `copy-file-${Date.now()}`;

  toasterCopy.loading({
    id,
  });

  try {
    const file = await getFile();

    await navigator.clipboard.write([new ClipboardItem({ [file.type]: file })]);

    toasterCopy.update(id, {
      type: 'success',
    });
  } catch (err) {
    console.error(err);
    toasterCopy.update(id, {
      type: 'error',
    });
  }
}
